'use strict';

require('es5-shim');
require('es5-shim/es5-sham');

require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/target/es5.js
// module id = 253
// module chunks = 35783957827783 172322841747965